import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { EasFormGroupComponent } from './easform-group.component';
import { EasFormArrayComponent } from './easform-array.component';
import { EasFormControlComponent } from './easform-control.component';
import { MaterialModule } from '@fry/components/material';
import { FryCommonModule } from '../common.module';
import { EasFormDialogComponent } from './easform-dialog.component';
import { UnboxedModule } from '@fry/ui';
import { EasFormElementComponent } from './easform-element.component';
import { FileUploadControlModule } from '@fry/components/common/file-upload-control/file-upload-control.module';
import { EasFormControlSelectComponent } from './easform-control-select.component';
import { EasFormControlSingleComponent } from './easform-control-single.component';
import { UIBadgeModule } from '@fry/ui/badge';
import { EasFormControlMultiSelectComponent } from './easform-control-multiselect.component';
import { QuillModule } from 'ngx-quill';
import { EasFormControlPasswordComponent } from './easform-control-password.component';

const components = [
  EasFormGroupComponent,
  EasFormArrayComponent,
  EasFormControlComponent,
  EasFormDialogComponent,
  EasFormElementComponent,
  EasFormControlSelectComponent,
  EasFormControlSingleComponent,
  EasFormControlMultiSelectComponent,
  EasFormControlPasswordComponent,
];

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FryCommonModule,
    UnboxedModule,
    MaterialModule,
    FileUploadControlModule,
    UIBadgeModule,
    QuillModule.forRoot({
      bounds: 'quill-editor', // or a different css selector, see DK-3247
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'size': ['small', false, 'large', 'huge'] }],
          [{ 'align': [] }],
          ['link', 'image'],
          ['clean'],
        ]
      }
    }),
  ],
  providers: [
  ],
  exports: components
})
export class EasFormModule { }
